<template>
<v-content>
  <v-container fluid>
    <div id="content">
      <h2>{{ $route.name }}</h2>

      <section>
        <v-card flat>
          <v-card-title>
            <v-icon class="mr-2">fas fa-search</v-icon>
            <v-text-field v-model="listSearch" label="検索キーワード" single-line hide-details outlined dense></v-text-field>
            <v-spacer></v-spacer>
            <v-btn fab small color="primary" @click="dialog = true">
              <v-icon>fas fa-plus</v-icon>
            </v-btn>
          </v-card-title>
          <v-data-table
            :headers="columns"
            :items="desserts"
            :search="listSearch"
            sort-by="create_date"
            :sort-desc="true"
            mobile-breakpoint="800"
            class="row-enabled"
            @click:row="onRowClick">
            <template v-slot:item.roles="props">
              <v-chip v-for="(role, index) in displayRoles(props.item.roles)" :key="index" class="mr-2" color="primary" small label>
                {{ role }}
              </v-chip>
            </template>
          </v-data-table>
        </v-card>
      </section>

      <!-- 編集ダイアログ -->
      <v-dialog v-model="dialog" max-width="800px" :persistent="true">
        <v-card>
          <v-card-title class="dialog-header">
            <span class="title font-weight-light">{{ formTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-form v-model="valid">
              <v-row no-gutters>
                <v-col cols="12" sm="6" class="pa-2">
                  <v-text-field ref="email" v-model="editedItem.email" :rules="[rules.email]" :disabled="disabled">
                    <template v-slot:label>
                      <span class="required">メールアドレス</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" class="pa-2">
                  <v-text-field ref="passwd" type="password" v-model="editedItem.passwd" :rules="[rules.required, rules.min6]" :disabled="disabled">
                    <template v-slot:label>
                      <span class="required">パスワード</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="pa-2">
                  <v-text-field ref="company" v-model="editedItem.company" :rules="[rules.required]">
                    <template v-slot:label>
                      <span class="required">会社名</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6" sm="3" class="pa-2">
                  <v-text-field ref="post" v-model="editedItem.post" :rules="[rules.required]" v-mask="postMask" prefix="〒">
                    <template v-slot:label>
                      <span class="required">郵便番号</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6" sm="3" class="pa-2">
                  <v-combobox ref="pref" v-model="editedItem.pref" :items="prefs" :rules="[rules.required]">
                    <template v-slot:label>
                      <span class="required">都道府県</span>
                    </template>
                  </v-combobox>
                </v-col>
                <v-col cols="12" sm="6" class="pa-2">
                  <v-text-field ref="address" v-model="editedItem.address" :rules="[rules.required]">
                    <template v-slot:label>
                      <span class="required">住所</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6" class="pa-2">
                  <v-text-field ref="tel" v-model="editedItem.tel" :rules="[rules.required]">
                    <template v-slot:label>
                      <span class="required">電話番号</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6" class="pa-2">
                  <v-text-field ref="fax" v-model="editedItem.fax">
                    <template v-slot:label>
                      <span>FAX番号</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" class="pa-2">
                  <v-text-field ref="charge" v-model="editedItem.charge" :rules="[rules.required]">
                    <template v-slot:label>
                      <span class="required">担当者名</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="pa-2">
                  <v-combobox ref="roles" v-model="editedItem.roles" :items="roles" :rules="[rules.required, rules.empty]" @input="rolesCheck" multiple small-chips>
                    <template v-slot:label>
                      <span class="required">ロール</span>
                    </template>
                    <template v-slot:selection="{ item, parent, selected }">
                      <v-chip :input-value="selected" label small color="primary">
                        <span class="pr-2">{{ item }}</span>
                        <v-icon small @click="parent.selectItem(item)">fas fa-times</v-icon>
                      </v-chip>
                    </template>
                  </v-combobox>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="dialog-footer">
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="save" :loading="saving" :disabled="!valid">
              <v-icon left>fas fa-save</v-icon>登録
            </v-btn>
            <v-btn color="error" @click="deleteItem" :loading="saving" v-if="editedIndex > -1">
              <v-icon left>fas fa-trash-alt</v-icon>削除
            </v-btn>
            <v-btn @click="close">
              <v-icon left>fas fa-times</v-icon>閉じる
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </div>
  </v-container>
</v-content>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import { mask } from 'vue-the-mask'

export default {
  data() {
    return {
      valid: false,
      saving: false,
      dialog: false,
      desserts: [],
      roles: [],
      listSearch: null,
      columns: [
        { text: 'メールアドレス', value: 'email' },
        { text: '会社名', value: 'company' },
        { text: '電話番号', value: 'tel' },
        { text: '担当者', value: 'charge' },
        { text: 'ロール', value: 'roles', sortable: false },
        { text: '登録日', value: 'create_date' },
      ],
      editedIndex: -1,
      editedItem: {},
      postMask: '###-####',
    }
  },
  prop: {},
  mounted() {},
  created() {
    this.setLoading(true)
    let timer = setInterval(() => {
      if (this.getMyself()) {
        clearInterval(timer)
        this.init()
      }
    }, 100)
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'アカウントの追加' : 'アカウントの編集'
    },
    disabled() {
      return this.editedIndex !== -1 ? true : false
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
  },
  methods: {
    init() {
      const path = this
      //アカウント
      firebase.database().ref('users').on('child_added', (data) => {
        path.updateUser(data.key, data.val())
      })
      firebase.database().ref('users').on('child_changed', (data) => {
        path.updateUser(data.key, data.val())
      })
      firebase.database().ref('users').on('child_removed', (data) => {
        path.desserts = path.desserts.filter(e => e.id !== data.key)
      })
      //ロール
      firebase.database().ref('roles').on('child_added', (data) => {
        path.roles.push(data.val().name)
      })
      this.setLoading(false)
    },
    updateUser(key, item) {
      const user = Object.assign({
        id: key,
        roles: [],
      }, item)
      let u_origin = this.desserts.find(e => e.id === key)
      if (u_origin) {
        u_origin = Object.assign(u_origin, user)
      } else {
        this.desserts.push(user)
      }
    },
    onRowClick(params) {
      this.editedIndex = this.desserts.findIndex(e => e.id === params.id)
      this.editedItem = Object.assign({}, params)
      this.dialog = true
    },
    deleteItem() {
      const path = this
      if (confirm(this.editedItem.email + ' を削除しますか？')) {
        this.saving = true
        //追加
        this.$http.get('/deleteUser', {
          params: {
            uid: this.editedItem.id,
          }
        }).then(() => {
          //アカウントの削除
          firebase.database().ref('users/' + this.editedItem.id).set(null, function(error) {
            if (error) {
              path.myAlert('アカウントの削除に失敗しました')
            } else {
              path.log(path.getMyself().id, 'アカウント削除 = ' + path.editedItem.email)
              path.close()
            }
          })
        }).catch(error => {
          this.myAlert('アカウントの削除に失敗しました')
          path.log(path.getMyself().id, 'アカウントを削除 = ' + error)
        })
      }
    },
    close() {
      this.saving = false
      this.dialog = false
      setTimeout(() => {
        this.resetForm()
        this.editedIndex = -1
      }, 300)
    },
    //社員情報の保存
    save() {
      let validate = true
      Object.keys(this.$refs).forEach(f => {
        if (!this.$refs[f].validate(true)) validate = false
      })

      if (validate) {
        const path = this
        this.saving = true

        let data = Object.assign({}, this.editedItem)
        delete data.id
        Object.keys(data).forEach(f => {
          data[f] = data[f] || null
        })

        if (this.editedIndex > -1) {
          data.update_date = this.getNowStr()
          //更新
          firebase.database().ref('users/' + this.editedItem.id).update(data, function(error) {
            if (error) {
              this.myAlert('アカウントの更新に失敗しました')
            } else {
              path.log(path.getMyself().id, 'アカウントを更新 = ' + data.email)
              path.close()
            }
          })

        } else {
          data.create_date = this.getNowStr()
          //追加
          this.$http.get('/createUser', {
            params: {
              email: data.email,
              passwd: data.passwd,
            }
          }).then(res => {
            firebase.database().ref('users/' + res.data.uid).set(data, function(error) {
              if (error) {
                this.myAlert('アカウントの登録に失敗しました')
              } else {
                path.log(path.getMyself().id, 'アカウントを追加 = ' + data.email)
                path.close()
              }
            })
          }).catch(error => {
            this.myAlert('アカウントの登録に失敗しました')
            path.log(path.getMyself().id, 'アカウントを追加 = ' + error)
          })
        }
      }
    },
    //ロールのチェック（無ければ追加する）
    rolesCheck() {
      let path = this
      this.editedItem.roles.forEach(function(tag) {
        if (!path.roles.find(cate => cate === tag)) {
          //追加
          const newKey = firebase.database().ref('roles').push().key
          firebase.database().ref('roles/' + newKey).set({ name: tag }, function(error) {
            if (error) {
              //console.log('タグの登録に失敗しました')
            }
          })
        }
      })
    },
    resetForm() {
      Object.keys(this.$refs).forEach(f => {
        this.$refs[f].reset()
      })
    },
    displayRoles(roles) {
      const map = []
      roles.forEach(r => map.push(r))
      return map
    },
  },
  directives: {
    mask,
  },
}
</script>

<style>

</style>
